/* import __COLOCATED_TEMPLATE__ from './desktop-menu.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './desktop-menu.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteDesktopMenu extends Component {}
